import { useDisposables as o } from "./index547.js";
function t() {
  let e = o();
  return (s) => {
    e.dispose(), e.nextFrame(s);
  };
}
export {
  t as useFrameDebounce
};
